
<template>
  <vs-popup class="holamundo" popup-class="w-9/12" :title='`ویرایش وضعیت پذیرنده "${name}"`' :active.sync="popupActive">
    <div class="vx-row mt-7 mb-12">
      <div class="vx-col w-full">شماره تلفن همراه:</div>
      <div class="vx-col w-full">
            <vs-input
              v-validate="{ required: true, regex: '^([+]98|0)?9[0-9]{9}$' }"
              inputmode="numeric"
              label="تلفن همراه"
              name="mobile"
              v-model="mobile"
              class="w-full"
            />
        <span class="text-danger text-sm" v-show="errors.has('mobile')">شماره تلفن همراه را بدرستی وارد کنید</span>
      </div>
    </div>
    <div class="vx-row mt-12 mb-11">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="save">ذخیره</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="popupActive=false">انصراف</vs-button>
      </div>
    </div>
  </vs-popup>
</template>
<style>
</style>
<script>
import { Validator } from "vee-validate";

export default {
  name: "edit-mobile",
  data() {
    return {
      popupActive: false,
      id: 0,
      name:'',
      mobile:'',
    };
  },
  methods: {
    save() {
      let loading = this.$vs.loading();
      const payload={
        id:this.id,
        mobile:this.mobile,
      }
      this.$http
        .post("/api/services/app/Draft/EditMobile", payload)
        .then(response => {
          if (response.data.success) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "شماره تلفن همراه با موفقیت تغییر یافت"
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id,name,mobile) {
      this.id=id;
      this.name=name;
      this.mobile=mobile;
      this.popupActive = true;
    },
  },
  mounted() {}
};
</script>